import { Entity, Field } from 'typegraph';

import { ISubscription } from 'common/entities/courseWrapper/CourseWrapper';

enum Completion {
	NotStarted = "NotStarted",
	Started = "Started",
	Incomplete = "Incomplete",
	Completed = "Completed",
	Passed = "Passed",
	Failed = "Failed"
}

enum Status {
	Active, Inactive, Expired, Deleted, Withdrawn, Candidate, Finished, Suspended
}

@Entity({one: "subscriptionUser", many: "subscriptionsUser"})
export default class Subscription implements ISubscription {

	@Field()
	public id: string;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public completion: Completion;

	@Field()
	public completedOn: string;

	@Field()
	public status: Status;

}



// WEBPACK FOOTER //
// ./src/panels/recommended/entities/Subscription.ts